import { Slide, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'

import Button from '@/modules/shared/components/button/Button'
import { CloseIcon } from '@/modules/shared/icons/CloseIcon'

export const ToastContainerItem = () => {
  const renderCloseButton = ({ closeToast }: { closeToast: (e: React.MouseEvent<HTMLElement>) => void }) => (
    <Button onClick={closeToast} className="mx-1">
      <CloseIcon className="size-6 text-gray-300 transition duration-200 hover:text-gray-400" />
    </Button>
  )
  // used to ignore the toast container from the meticulous testing
  const toastContainerClassName = 'meticulous-ignore'
  return (
    <ToastContainer
      className={toastContainerClassName}
      position="bottom-left"
      autoClose={5000}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      closeButton={renderCloseButton}
      transition={Slide}
    />
  )
}
